import api from "./index";

export interface UsersListParams {
  username?: string;
  email?: string;
  enabled?: boolean;
  lastLoginMin?: Date;
  lastLoginMax?: Date;
  firstName?: string;
  lastName?: string;
  middleName?: string;
  searchField?: string;
  gender?: 1 | 0;
  birthdayMin?: Date;
  birthdayMax?: Date;
  registeredAtMin?: Date;
  registeredAtMax?: Date;
  phone?: string;
  vk?: string;
  ok?: string;
  fb?: string;
  skype?: string;
  telegram?: string;
  viber?: string;
  whatsapp?: string;
  snils?: string;
  sort?: "registeredAt";
  order?: "ASC" | "DESC";
  limit?: number;
  offset?: number;
  options?: any;
}

/**
 * Decorator of UserApi.list method.
 * @param params
 * @param options
 */
export default (params: UsersListParams, options?: any) => {
  return api.UsersApi.list(
    params.username,
    params.email,
    params.enabled,
    params.lastLoginMin,
    params.lastLoginMax,
    params.firstName,
    params.lastName,
    params.middleName,
    params.searchField,
    params.gender,
    params.birthdayMin,
    params.birthdayMax,
    params.registeredAtMin,
    params.registeredAtMax,
    params.phone,
    params.vk,
    params.ok,
    params.fb,
    params.skype,
    params.telegram,
    params.viber,
    params.whatsapp,
    params.snils,
    params.sort,
    params.order,
    params.limit,
    params.offset,
    options
  );
};
